import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Description,
  ClientDTO,
  TTMap,
  SearchByOptions,
  Category
} from 'src/store/workspace/workspace.model';
import {
  Observable,
  Subscription,
  combineLatest
} from 'rxjs';
import {
  Store
} from '@ngrx/store';
import * as fromRoot from 'src/store';
import * as fromWorkspace from 'src/store/workspace';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  GridComponent,
  PagerSettings,
  PageChangeEvent
} from '@progress/kendo-angular-grid';
import {
  isNumber,
  cloneDeep
} from 'lodash';
import {
  SortDescriptor,
  orderBy
} from '@progress/kendo-data-query';

@Component({
  selector: 'app-descriptions',
  templateUrl: './descriptions.component.html',
  styleUrls: ['./descriptions.component.scss']
})
export class DescriptionsComponent {
  gridData$: Observable < [Description[], number | 'all', SearchByOptions, TTMap < Category > ] > ;
  gridData: Description[];
  gridSubs: Subscription;

  descriptions: Description[];
  alldescriptions: Description[];

  clients$: Observable < TTMap < ClientDTO >> ;
  clientsMap: TTMap < ClientDTO > ;
  clientsSubs: Subscription;
  clients: ClientDTO[];
  currentClientID: number;

  categories$: Observable < TTMap < Category >> ;
  categoriesMap: TTMap < Category > ;
  categoriesSubs: Subscription;
  categories: Category[];
  filteredCategories: Category[];
  currentCategoryID: number;

  editedRowIndex: number;
  formGroup: FormGroup;

  public pageSize: number | 'all' = 'all';
  public skip = 0;
  public length: number;
  public pageable: PagerSettings = {
    pageSizes: true,
    previousNext: true,
    info: true
  };
  public pageSizes: any[] = [10, 20, 30, 40, 50, {
    text: 'All',
    value: 'all'
  }];

  public sort: SortDescriptor[];
  public sortable = {
    allowUnsort: true,
    mode: 'single'
  };

  @ViewChild('grid', {
    static: false
  }) grid: GridComponent;

  public columns: any[] = [{
      field: 'descriptionID',
      hidden: true
    },
    {
      field: 'clientName',
      title: 'Client Name',
    },
    {
      field: 'category',
      title: 'Category',
    },
    {
      field: 'description',
      title: 'Description'
    },
  ];
  constructor(private store: Store < fromRoot.AppState > , private formBuilder: FormBuilder) {
    this.store.dispatch(new fromWorkspace.LoadDescriptions());
    this.store.dispatch(new fromWorkspace.LoadDescriptionsPageSize());
    this.sort = [];
    this.gridData$ = combineLatest(
      this.store.select(state => {
        const descriptions = [];
        Object.values(state.workspace.descriptions).forEach(
          item => {
            let items = Object.values(item);
            items = items.filter(d => d.viewInAdminScreen);
            descriptions.push(...items);
          }
        );
        return descriptions;
      }),
      this.store.select(state => state.workspace.descriptionsPageSize),
      this.store.select(state => state.workspace.searchByOptions),
      this.store.select(state => state.workspace.categories),
    );
    this.clients$ = this.store.select(state => state.workspace.clients);
    this.clientsSubs = this.clients$.subscribe(clients => {
      this.clientsMap = clients;
      this.clients = Object.values(clients).sort((a, b) => {
        if (a.clientName.toLowerCase() > b.clientName.toLowerCase()) {
          return 1;
        }
        if (a.clientName.toLowerCase() < b.clientName.toLowerCase()) {
          return -1;
        }
        return 0;
      }).filter(client => client.active && client.categorizeBilling);
    });
    this.gridSubs = this.gridData$.subscribe(([descriptions, pageSize, searchByOptions, categories]) => {
      if (this.grid && descriptions.length !== this.alldescriptions.length) {
        // this.closeEditor(this.grid);
      }
      if (searchByOptions.client && searchByOptions.client.clientID) {
        if (this.currentClientID !== searchByOptions.client.clientID) {
          this.resetToFirstPage();
          this.currentClientID = searchByOptions.client.clientID;
        }
        descriptions = descriptions.filter(d => d.clientID === searchByOptions.client.clientID);
      }
      if (searchByOptions.category && searchByOptions.category.categoryID) {
        if (this.currentCategoryID !== searchByOptions.category.categoryID) {
          this.resetToFirstPage();
          this.currentCategoryID = searchByOptions.category.categoryID;
        }
        descriptions = descriptions.filter(d => d.categoryID === searchByOptions.category.categoryID);
      }
      descriptions = descriptions.map(d => {
        const desc = cloneDeep(d);
        desc.clientName = this.clientsMap[d.clientID].clientName;
        desc.category = categories[d.categoryID].category;
        return desc;
      })
      descriptions = orderBy(descriptions, this.sort);
      this.length = descriptions.length;
      this.pageSize = pageSize;
      if (!isNumber(pageSize) && this.length) {
        this.pageSize = this.length || 10;
      }
      this.alldescriptions = descriptions;
      const size = this.pageSize as number;
      this.gridData = descriptions.slice(this.skip, this.skip + size);
      this.categoriesMap = categories;
      this.categories = Object.values(categories);
    });
    this.store.dispatch(new fromWorkspace.LoadDescriptionsPageSize());
    this.store.select(state => state.workspace.descriptionsPageSize).subscribe(size => {
      this.pageSize = size;
    });
  }

  public clientChanged(clientID: number) {
    if (clientID) {
      this.filteredCategories = this.categories.filter(cat => cat.clientID === clientID);
    }
  }

  public flipActiveFlag(description: Description) {
    const d = cloneDeep(description);
    this.store.dispatch(new fromWorkspace.UpdateDescription(d));
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.store.dispatch(new fromWorkspace.LoadDescriptions());
  }

  public resetToFirstPage() {
    let size: number;
    if (this.pageSize === 'all') {
      size = this.length;
    } else {
      size = this.pageSize;
    }
    this.pageChange({skip: 0, take: size});
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let pageSize: number | 'all' = event.take;
    if (pageSize === this.length) {
      pageSize = 'all';
    }
    this.store.dispatch(new fromWorkspace.SetDescriptionsPageSize(pageSize));
    this.store.dispatch(new fromWorkspace.LoadDescriptions());
  }


  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  public addHandler({
    sender
  }) {
    this.closeEditor(sender);
    const c: Description = {
      descriptionID: null,
      description: null,
      clientID: null,
      categoryID: null,
      active: true
    };
    this.formGroup = this.createFormGroup(c);

    sender.addRow(this.formGroup);
  }

  public cancelHandler({
    rowIndex
  }) {
    this.grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  public createFormGroup(dataItem: Description): FormGroup {
    return this.formBuilder.group({
      descriptionID: [dataItem.descriptionID],
      description: [dataItem.description, Validators.required],
      clientID: [dataItem.clientID, Validators.required],
      categoryID: [dataItem.categoryID]
    });
  }
  public saveHandler({
    rowIndex,
    formGroup
  }): void {
    this.store.dispatch(new fromWorkspace.AddDescription(formGroup.value));
    this.grid.closeRow(rowIndex);
  }
}
